import { Pressable } from 'components/Pressable';
import * as React from 'react';
import { Platform, StyleSheet } from 'react-native';
import { useDispatch } from 'react-redux';
import { RESET_DEV } from 'store/actions';
import * as Updates from 'expo-updates';
import { ICONS, Icon } from 'components/Icon';
import { theme } from 'lib/theme';

const CIRCLE_SIZE = 50;

export const DevIndicator = (): React.ReactElement | null => {
  const dispatch = useDispatch();
  if (!__DEV__) {
    return null;
  }
  return (
    <Pressable
      onPress={() => {
        dispatch(RESET_DEV());
        setTimeout(() => {
          if (Platform.OS === 'web') {
            window.location.reload();
          } else {
            Updates.reloadAsync();
          }
        }, 1000);
      }}
      style={styles.container}
    >
      <Icon
        source={ICONS.LifeRingLight}
        size={CIRCLE_SIZE / 2}
        color={theme.colors.white}
      />
    </Pressable>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#999999',
    shadowColor: '#999999',
    alignItems: 'center',
    borderRadius: CIRCLE_SIZE,
    elevation: 99,
    flexDirection: 'column',
    height: CIRCLE_SIZE,
    justifyContent: 'center',
    opacity: 0.1,
    shadowOffset: { height: 0, width: 0 },
    zIndex: 99999,
    shadowOpacity: 0.8,
    shadowRadius: 0,
    textAlign: 'center',
    width: CIRCLE_SIZE,
  },
});
